import React, {Component} from 'react';
import SystemServicesController from '../../controllers/system-services';
import './KaitenInfo.css';
import '../../css/styles.css'
import {KaitenCard, KaitenOutputData} from '../../../../../KaitenServer/src/DataSource/DataSet/dataset';
import BarExpiration from '../../components/bar/barexpiration';
import Bars from '../../components/bar/bars';
import Member from '../../components/Member';
//'D:/Project/NJSPROJECTS/KaitenProjectsDeadLineList/KaitenServer/src/DataSource/DataSet/dataset';

function msecToDays(msec:number): number {
  return (msec/(24*60*60*1000)>>0);//возвращаю целое число
}

interface IKaitenData {
  cards: Array<KaitenCard>,
  maxExpirationDays: number,
  maxDaysOfNormalProgress: number,
  error: boolean
}

export default class KitenInfoBlock extends Component <{}, IKaitenData> {

  private updateTimer: any = undefined;

  constructor (props?:any) {
    super(props);
    this.state = {
      cards:[],
      maxExpirationDays: 0,
      maxDaysOfNormalProgress: 0,
      error: true
    }
  }

  private async updateKitenInfo(){
    try {
      const data: KaitenOutputData = await SystemServicesController.getKaitenInfo();
      this.setState({...data});
      console.log(this.state.maxDaysOfNormalProgress,
        this.state.maxExpirationDays);
    } catch (e) {
      console.log(e);
      this.setState({cards:[],
                    maxExpirationDays: 0,
                    maxDaysOfNormalProgress: 0,
                    error: true
                  });
    }
  }

  componentDidMount(){
    this.updateKitenInfo();
    this.updateTimer = setInterval(async ()=>{this.updateKitenInfo()}, 60000);
  }

  componentWillUnmount(){
    clearInterval(this.updateTimer);
  }

  private getDaysFromStartToStop(el: KaitenCard): {daysInProgress: number,
                                                   daysOfNormalProgress: number,
                                                   daysToDeadline: number} {
    /*
    this.daysInProgress = msecToDays(now - createDate);
    this.daysOfNormalProgress = msecToDays(due - createDate);
    */
    const daysOfNormalProgress: number = el.daysOfNormalProgress;//это будет длиной индикатора
    //и он состоит дих двух частей:
    //daysInProgress сколько дней прошло в нормальном режиме, и когда прошла просрочка то daysInProgress становится 
    // равным daysOfNormalProgress и уже не меняется.
    //daysToDeadline и сколько осталось до дедлайна , если пошла просрочка, то daysToDeadline становится отрицательным
    // а значит его можно сделать нулём
    const daysInProgress: number = el.daysInProgress;
    const countDaysToDeadline = ((el.daysOfNormalProgress - el.daysInProgress) > 0)
                                ? el.daysOfNormalProgress - el.daysInProgress
                                : 0;
    const daysToDeadline: number = countDaysToDeadline;
    return {daysInProgress, daysOfNormalProgress, daysToDeadline};
    //return `${daysInProgress}/${daysOfNormalProgress}/${daysToDeadline}`;
  }

  private getExpirationDays(el: KaitenCard): string {
    /*отрицательное значение daysOfExpiration означает отсутствие просрочки*/
    const numDays: number = (el.daysOfExpiration >= 0)? el.daysOfExpiration : 0; 
    const days: string = numDays.toString();
    return days;
  }

  private getCardTitle(el: KaitenCard): string {
    /*TODO убрать из строки"/n" */
    return el.title;
  }

  private getCardURL(el: KaitenCard): string {
    //https://intmash.kaiten.ru/space/184803/card/15951885
    return `https://intmash.kaiten.ru/space/${el.space_id}/card/${el.id}`;
  }

  private getDaysInProduction(el: KaitenCard): string {
    /*TODO обработка Карты находящейся в столбце "Готовность к сборке" */
    if (el.column.title === "Готовность к сборке") {
      const now: number = Date.now();
      const inProdDate: number = new Date(el.column_changed_at).getTime();
      const inProdDays: number = msecToDays(now - inProdDate);
      return inProdDays.toString();
    }
    return "";
  }

  private getMembersPictures(el: KaitenCard): React.ReactElement {
    const {members} = el;
    const imgs = members.map((item:any) => <Member key={item.id} member={item}/>);
    return (<>{imgs}</>);
  }

  private getDueDate(el:KaitenCard): string {
    let res: string =  "⭕️";
    if (el.isDueDateSet){
      let dueMonth: number = new Date(el.due_date).getMonth() + 1;
      let dueDay: number = new Date(el.due_date).getDate();
      /*преобразовать дата/время в dd'mm - день/месяц, отсеяв всё остальное */
      return `${dueDay}/${dueMonth}`;
    }
    return res;
  }

  private getServerErrorStatus(): string{
    return (this.state.error)
            ?"🔴"
            :"🟢";
  }

  /**TODO https://ru.stackoverflow.com/questions/660741/Как-нарисовать-дугу-на-svg-для-сайта
   * классный получится индикатор времени до повторного запроса данных
   */
  render() {
    return(
      <div className="jumbotron">
        <h3>Состояние заказов {this.getServerErrorStatus()}</h3>
        <div className="container">
          <table style={{width: "100%"}}>
            <thead className='text-shadow'>
              <tr>
                <th>#</th>
                <th style={{width: "13%"}}>Осталось</th>
                <th>🕑</th>
                <th style={{width: "13%"}}>Просрочка</th>
                <th >😎</th>
                <th title='КД передано.
                          Стадия "Готовность к сборке"'>ДиП</th>
                <th>URL</th>
                <th>Заказ</th>
              </tr>
            </thead>
            <tbody className='vert-align-top'>
              {this.state.cards.map((el:KaitenCard, index: number) =>
                <tr key={el.id}>
                  <td className='border-bottom'>{index}</td>
                  <td className='border-bottom'><Bars {...this.getDaysFromStartToStop(el)}
                                                        maxDaysOfNormalProgress = {this.state.maxDaysOfNormalProgress}/></td>
                  <td className='border-bottom vert-align-top font-weight-bold text-shadow'>{this.getDueDate(el)}</td>
                  <td className='border-bottom'>{(this.getExpirationDays(el) !== "0")
                                              ?<BarExpiration color={0}
                                                   maxWidth={this.state.maxExpirationDays}
                                                   width={Number(this.getExpirationDays(el))}/>
                                              :""}</td>
                  <td className='border-bottom'><div className='display-flex'>{this.getMembersPictures(el)}</div></td>
                  <td className='border-bottom'>{this.getDaysInProduction(el)}</td>
                  <td className='border-bottom'><a className='none' href={this.getCardURL(el)} target="_blank"><img className='img-opacity none' src="icons8-external-link-squared-32.png" alt="" /></a></td>
                  <td className='border-bottom font-small font-weight-600 opacity-0-8' align="left">{this.getCardTitle(el)}</td>
                </tr>
              )}
            </tbody>
          </table>
          <ul>

          </ul>
        </div>
      </div>
    )
  }
}